class GameLogic {

    constructor(terms) {
        this.terms = terms;
        this.currentTermIndex = 0;
    }

    getFirstThreeTerms() {
        this.currentTermIndex = 1;
        return [this.terms[0], this.terms[1], this.terms[2]]
    }

    getNextTerm() {
        this.currentTermIndex++;
        return this.terms[this.currentTermIndex + 2];
    }

    getThreeDifferentTermsByName(requestedTerms) {
        var firstTerm = this.terms.filter(this.isRequestedTerm(requestedTerms.first))[0] || this.terms[0];
        var secondTerm = this.terms.filter(this.isRequestedTerm(requestedTerms.second))[0] || this.terms[1];
        var thirdTerm = this.terms.filter(term => {
            if (requestedTerms.first && requestedTerms.second) {
                return term.keyword.toLowerCase() !== requestedTerms.first.toLowerCase() && term.keyword.toLowerCase() !== requestedTerms.second.toLowerCase();
            }
            return false;  
        })[0] || this.terms[2];

        return [firstTerm, secondTerm, thirdTerm];
    }

    isRequestedTerm(requestedKeyword) {
        return function(term) {
            if (requestedKeyword) {
                return term.keyword.toLowerCase() === requestedKeyword.toLowerCase();
            }
            return false;
        }
    }

    getDifferentTerm(previous, current) {
        var _questionData = this.terms;

        for (var i = 0; i < _questionData.length; i++) {
            var question = _questionData[i];
            if (question.keyword !== current && question.keyword !== previous) {
                return question
            }
        }
    }

    currentValueIsLowerThanPrevious(current, previous) {
        return parseInt(current, 10) <= parseInt(previous, 10);
    }

    currentValueIsHigherThanPrevious(current, previous) {
        return parseInt(current, 10) >= parseInt(previous, 10);
    }
}

export default GameLogic;


// WEBPACK FOOTER //
// ./src/components/game/gameLogic.js